// @flow
import './editor.css'

import { useFormikContext } from 'formik'
import * as React from 'react'

import { TextEditor } from '@/components/TextEditor'

type Props = {
  field: {
    name: string,
    value: string,
    onChange: (any) => void,
  },
  placeholder: string,
}

export function SettingsEmailMessageInput({
  field,
  placeholder,
}: Props): React.Node {
  const { setFieldValue } = useFormikContext()

  const onChange = React.useCallback(
    (value) => setFieldValue(field.name, value),
    [field.name, setFieldValue]
  )

  return (
    <TextEditor
      className="text-sm"
      minHeight={140}
      onChange={onChange}
      placeholder={placeholder}
      value={field.value}
    />
  )
}
